// Start an illustration once its top is a quarter of the way into the viewport.
// Keep this separate from the full-viewport observer that pauses playback.
export function observeViewportEntry(element, onEnter) {
  let observer
  const stop = () => {
    observer.disconnect()
    window.removeEventListener("resize", observe)
  }
  const observe = () => {
    observer?.disconnect()
    observer = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) return
      stop()
      onEnter()
    }, {
      // Percentage root margins resolve against width, so use viewport-height pixels.
      rootMargin: `0px 0px -${window.innerHeight / 4}px 0px`,
      threshold: 0
    })
    observer.observe(element)
  }
  window.addEventListener("resize", observe)
  observe()
  return stop
}
